import React from 'react';

function Custom() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<mask
				id="mask0_2415_22027"
				// style="mask-type:alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="24"
				height="24">
				<rect width="24" height="24" fill="#D9D9D9" />
			</mask>
			<g mask="url(#mask0_2415_22027)">
				<path
					d="M15 20V18H11V13H9V15H2V9H9V11H11V6H15V4H22V10H15V8H13V16H15V14H22V20H15ZM17 18H20V16H17V18ZM4 13H7V11H4V13ZM17 8H20V6H17V8Z"
					fill="#1C1B1F"
				/>
			</g>
		</svg>
	);
}

export default Custom;
